import MainAppProvider from "provider/app";
import { IApp } from "provider/app/interface";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IAuthContext } from "./interface";

const AuthProviderContext = createContext<IAuthContext>({});

const AuthProvider = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const navigate = useNavigate();
  const [app, setApp] = useState<IApp>({});
  const { pathname } = useLocation();

  useEffect(() => {
    const _redirect = () => {
      if (pathname === "/") {
        navigate("/display/presto-solar-flare", { replace: true });
      }
    };
    _redirect();
  }, [navigate, pathname]);

  return (
    <MainAppProvider value={{ app: app, setApp: setApp }}>
      <>{children}</>
    </MainAppProvider>
  );
};
export const useAuth = () => useContext(AuthProviderContext);
export default AuthProvider;
